module.exports = __webpack_public_path__ + "img/bg1.6b89f0b7.jpg";